import { useMemo } from 'react'
import { base64ToBlob, fileHelper } from '../../common/helpers/fileHelper'
import { UserDocumentDto } from '@ringo/shared'

interface FilePreviewProps {
    file: UserDocumentDto
}

const FilePreview = ({ file }: FilePreviewProps) => {
    const pdfUrl = useMemo(() => {
        if (fileHelper.isImage(file)) {
            return null
        }
        return URL.createObjectURL(base64ToBlob(`data:application/pdf;base64,${file.content}`, 'application/pdf'))
    }, [file])

    return (
        <div className="py-4 h-full">
            {fileHelper.isImage(file) ? (
                <img src={`data:image/jpeg;base64,${file.content}`} className="w-full" />
            ) : (
                <iframe src={pdfUrl!} className="w-full h-full" />
            )}
        </div>
    )
}

export default FilePreview
